import { graphql } from 'msw'
import successful from './fixtures/successful.json'
import children from './fixtures/children.json'
import unsuccessful from './fixtures/unsuccessful.json'

const step5 = [
	graphql.query('childrenQtyChoices', (req, res, ctx) => res(ctx.data(children))),
	graphql.mutation('createChildrenQty', (req, res, ctx) => {
		const { quantity } = req.variables
		if (quantity === 100) {
			return res(ctx.data(unsuccessful))
		}
		return res(ctx.data(successful))
	})
]

// eslint-disable-next-line import/prefer-default-export
export { step5 }
